var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        width: "380px",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "show-close": false,
        "append-to-body": "",
        "custom-class": "slider-verify-dialog",
      },
      on: { close: _vm.onDialogClose },
    },
    [
      _c("div", { staticClass: "slider-verify-header" }, [
        _vm._v("请确认你不是机器人"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "slider-verify-subtitle" }, [
        _vm._v("请通过滑块验证"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "slider-verify-body" }, [
        _c(
          "div",
          {
            staticClass: "slider-verify-wrap",
            class: { "is-locked": _vm.interactionLocked },
          },
          [
            _c("slide-verify", {
              key: _vm.slideVerifyKey,
              ref: "slideBlock",
              attrs: {
                l: 42,
                r: 10,
                w: 310,
                h: 155,
                imgs: _vm.sliderImages,
                "slider-text": "向右滑动滑块填充拼图",
              },
              on: {
                success: _vm.onSuccess,
                fail: _vm.onFail,
                again: _vm.onAgain,
                refresh: _vm.onRefresh,
              },
            }),
            _vm._v(" "),
            _vm.interactionLocked
              ? _c("div", { staticClass: "slider-lock-overlay" }, [
                  _c("i", { staticClass: "el-icon-lock slider-lock-icon" }),
                  _vm._v(" "),
                  _c("p", { staticClass: "slider-lock-title" }, [
                    _vm._v(_vm._s(_vm.lockTitle)),
                  ]),
                ])
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }